module.exports = __webpack_public_path__ + "static/portrait-4b1eb5f8bf0038d169c9a82722cd1c51.png";